// import logo from '../imanjeSolutionsLogo2.svg';
import logo from '../assets/headerLogo2.webp';
import './Header.css';
import NavBar from './NavBar';

function Header() {
  return (
    <header className="App-header">
        <div className="app-logo-container">
          <img src={logo} className="App-logo" alt="Imanje Solutions" />
        </div>
        <div className="app-title-container">
          <h1 className="app-title">Imanje Solutions</h1>
        </div>
        <NavBar />    
      </header>
  );
}

export default Header;
